<template>
	<div class="form-signin">
		<div class="align-self-center">
			<b-card style="max-width: 22rem" class="mb-2">
				<b-card-text>
					<div class="mb-3 text-center">
						<img :src="this.$store.state.layout.logo" alt="iAMc" width="auto" height="35" />
					</div>

					<div>
						<b-form @submit.stop.prevent>
							<b-form-group id="user_name" description="">
								<b-form-input
									v-model="register.member.user_name"
									type="text"
									required
									placeholder="Enter username"								
								></b-form-input>
								<div class="col-12" v-if="register.errors.user_name != ''">
									<small class="text-danger" v-text="register.errors.user_name"></small>
								</div>			
							</b-form-group>

							<b-form-group id="first_name" description="">
								<b-form-input
									v-model="register.member.first_name"
									type="text"
									required
									placeholder="Enter first name"		
								></b-form-input>
								<div class="col-12" v-if="register.errors.first_name != ''">
									<small class="text-danger" v-text="register.errors.first_name"></small>
								</div>
							</b-form-group>

							<b-form-group id="last_name" description="">
								<b-form-input
									v-model="register.member.last_name"
									type="text"
									required
									placeholder="Enter last name"
								></b-form-input>							
								<div class="col-12" v-if="register.errors.last_name != ''">
									<small class="text-danger" v-text="register.errors.last_name"></small>
								</div>							
							</b-form-group>

							<b-form-group id="email" description="">
								<b-form-input
									v-model="register.member.email"
									type="email"
									:formatter="formatter"
									required
									placeholder="Enter email"
								></b-form-input>
								<div class="col-12" v-if="register.errors.email != ''">
									<small class="text-danger" v-text="register.errors.email"></small>
								</div>							
							</b-form-group>

							<b-form-group id="phone" description="">
								<b-form-input
									v-model="register.member.phone"
									type="number"											
									placeholder="Enter phone number (optional)"
									onkeydown="return event.keyCode !== 69"
								></b-form-input>						
								<div class="col-12" v-if="register.errors.phone != ''">
									<small class="text-danger" v-text="register.errors.phone"></small>
								</div>						
							</b-form-group>
							
							<b-form-group id="password" description="">
								<b-form-input
									v-model="register.member.password"
									type="password"
									required
									placeholder="Enter password"
								></b-form-input>							
								<div class="col-12" v-if="register.errors.password != ''">
									<small class="text-danger" v-text="register.errors.password"></small>
								</div>							
							</b-form-group>						
							
							<b-form-group id="password2" description="">
								<b-form-input
									v-model="register.member.password2"
									type="password"
									required
									placeholder="Re-enter password"
								></b-form-input>
								<div class="col-12" v-if="register.errors.password2 != ''">
									<small class="text-danger" v-text="register.errors.password2"></small>
								</div>
							</b-form-group>		
						</b-form>

						<div v-if="processing == 0" class="text-center">
							<b-button block href="#" variant="primary" @click="doRegister()">
								<i class="fas fa-sign-in-alt"></i> Register
							</b-button>
						</div>
						<div v-else class="text-center gold">
							<i class="fas fa-atom fa-spin fa-2x"></i>
						</div>
						<div class="col-12" v-if="register.errors != ''">
							<small class="text-danger" v-text="errors.password"></small>
						</div>

						<div class="row small">
							<div class="col">
								<b-link @click="showLogin()" class="gold" v-text="'Login'"></b-link>
							</div>
							<div class="col text-right">
								<b-link @click="showForgot()" class="gold" v-text="'Forgot Password?'"></b-link>
							</div>
						</div>
					</div>
					
					<div class="text-center" v-if="register.errors.register != ''">
						<div class="col-12">
							<small :class="register.errors.register_class" v-text="register.errors.register"></small>
						</div>
					</div>
				</b-card-text>
			</b-card>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import * as Cookie from '@/assets/js/cookie.js';

export default {
	name: 'Login',
	props: {},
	data() {
		return {
			errors: {
				email: '',
				email_forgot: '',
				password: '',				
				login: '',
				login_class: 'text-danger',
				process: '',
			},
			email: null,
			password: null,
			processing: 0,
			register: {
				member: {
					id: 0,
					first_name: '',
					last_name: '',
					user_name: '',
					password: '',
					email: '',
					phone: '',
					status: 1,
					level: 20,
				},			
				disabled: false,
				submitDisabled: true,
				errors: {
					email: '',
					first_name: '',
					last_name: '',
					user_name: '',
					phone: '',
					password: '',	
					password2: '',			
					register: '',
					register_class: 'text-danger',
					process: '',
				},
			},
			show_login: 1,
			show_register: 0,
			show_forgot: 0,
		};
	},
	methods: {
		formatter(value) {
			return value.toLowerCase()
		},
		checkRegisterEmail(value) {
			if (!this.validEmail(value)) {
				this.register.errors.email = 'Email is invalid';
				this.disableSubmit = false;
				this.btn_update_class = 'btn-secondary';
				this.btn_update_icon = 'fa-pen';
				return false;
			} else {
				this.errors.email = '';
				return true;
			}
		},
		checkPassword() {
			if (this.register.member.password != this.register.member.password2) {
				this.register.errors.password2 = 'Passwords do not match!';
				return false;
			} else {
				this.register.errors.password2 = '';
				return true;
			}
		},
		checkInputs(type) {
			let valid = 0;

			this.register.errors.email = '';
			this.register.errors.password = '';
			this.register.errors.password2 = '';
			this.register.errors.user_name = '';
			this.register.errors.first_name = '';
			this.register.errors.last_name = '';

			if (type == 'register') {
				if (this.register.member.user_name === '' || this.register.member.user_name === null) {
					this.register.errors.user_name = 'Enter a username';
				} 
				else if (this.register.member.first_name === '' || this.register.member.first_name === null) {
					this.register.errors.first_name = 'Enter a first name';
				} 
				else if (!this.validName(this.register.member.first_name)) {
					this.register.errors.first_name = 'Enter a valid first name';
				}
				else if (this.register.member.last_name === '' || this.register.member.last_name === null) {
					this.register.errors.last_name = 'Enter a last name';
				}
				else if (!this.validName(this.register.member.last_name)) {
					this.register.errors.last_name = 'Enter a valid last name';
				}
				else if (this.register.member.email === '' || this.register.member.email === null) {
					this.register.errors.email = 'Enter an email';
				} 
				else if (!this.checkRegisterEmail(this.register.member.email)) {
					this.register.errors.email = 'Enter a valid email';
				} 						
				else if (this.register.member.password === '' || this.register.member.password === null) {
					this.register.errors.password = 'Enter a password';
				}
				else if (this.register.member.password.length < 9) {
					this.register.errors.password = 'Password must be longer than 8 characters';
				}
				else if (this.register.member.password2 === '' || this.register.member.password2 === null) {
					this.register.errors.password2 = 'Re-enter password';
				}
				else if (!this.checkPassword()) {
					this.register.errors.password2 = 'Password do not match!';
				}
				else {
					valid = 1;
				}
	
			}

			return valid;
		},
		clearRegister() {
			this.register.member.email = '';
			this.register.member.first_name = '';
			this.register.member.last_name = '';
			this.register.member.user_name = '';
			this.register.member.phone = '';
			this.register.member.password = '';
			this.register.member.password2 = '';
			this.register.member.disabled = true;
		},		
		getMenu(session_id) {
			let _this = this;
			axios({
				url: _this.$store.state.api_url + 'userMenuGet',
				params: {
					session_id: session_id,
				},
			})
				.then(function (response) {
					if (response.data.menu.status == 1) {
						_this.$store.commit('menuSet', response.data);
					}
				})
				.catch(function () {
					console.log('Error: getMenu.');
				});
		},
		doRegister() {
			console.log('register');
			
			let _this = this;
			if (this.checkInputs('register') == 0) return false;

			let params = new URLSearchParams();
			params.append('id', _this.register.member.id);
			params.append('first_name', _this.register.member.first_name);
			params.append('last_name', _this.register.member.last_name);
			params.append('user_name', _this.register.member.user_name);
			params.append('password', _this.register.member.password);
			params.append('email', _this.register.member.email);
			params.append('phone', _this.register.member.phone);
			params.append('status', _this.register.member.status);
			params.append('level', _this.register.member.level);
			params.append('token', _this.$store.state.session_id);

			axios({
				url: _this.$store.state.api_url + 'userAdd',
				params: params,
			})
				.then(function (response) {
					if (response.data.status == 1) {
							console.log('good');
							_this.register.errors.register_class = 'text-success';
							_this.register.errors.register = response.data.message;
							_this.loginAfterRegister();						
						} else {
							console.log('bad');
							_this.register.errors.register_class = 'text-danger';
							_this.register.errors.register = response.data.message;
							
						}
				})
				
				.catch(function () {});
		},
		loginAfterRegister() {
			console.log('login');
			let _this = this;

			let params = new URLSearchParams();
			params.append('email', _this.register.member.email);
			params.append('password', _this.register.member.password);

			axios({
				url: _this.$store.state.api_url + 'loginProcess',
				params: params,
			})
				.then(function (response) {
					if (response.data.status == 1) {
						_this.errors.login = 'Logging you In...';
						_this.$store.commit('profileSet', response.data);

						console.log('_this.$store.state.app_domain:' + _this.$store.state.app_domain);

						Cookie.setCookie(
							'user_session',
							response.data.profile.session_id,
							_this.$store.state.app_domain,
							'30'
						);

						if (Cookie.getCookie('user_session') == response.data.profile.session_id) {
							_this.getMenu(response.data.profile.session_id);
							_this.$router.push('/profile');
						} else {
							_this.errors.login = 'Session data Error...';
							Cookie.deleteCookie('user_session', _this.$store.state.app_domain);
							_this.errors.login_class = 'text-danger';
						}
					} else {
						_this.errors.login = response.data.message;
						Cookie.deleteCookie('user_session', _this.$store.state.app_domain);
						_this.errors.login_class = 'text-danger';
					}
				})
				.catch(function () {
					console.log('doLogin: error');
				});
		},
		toggle_forgot_form(val) {
			this.show_forgot = val;
		},
		showForgot() {
			this.$router.push('/login/forgot');
		},
		showLogin() {
			this.$router.push('/login');
		},
		validEmail(email) {
			var re =
				/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			var val = re.test(email);
			return val;
		},
		validName(name) {
			var letters = /^[A-Za-z]+$/;
			var val = letters.test(name);
			return val;
		},
	},
	created() {
		this.$store.state.show_loading = 0;
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.form-signin {
	width: 100%;
	max-width: 350px;
	padding: 15px;
	margin: 0 auto;
	margin-top: 15%;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button{
	-webkit-appearance: none;
	margin: 0;
}
</style>